import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@fb-tool-front/environments/environment';
import { Observable } from 'rxjs';
import { Stripe } from '@fb-tool-front/stripe/models/stripe.model';

export interface CheckoutSessionPostBody {
  client: string;
  price: string;
  success_url: string;
  cancel_url: string;
}

@Injectable({
  providedIn: 'root'
})
export class StripeService {
  private STRIPE_URL = `${environment.authHost}/api/stripe`;

  constructor(private http: HttpClient) {}

  public getProducts(): Observable<Stripe.Product[]> {
    return this.http.get<Stripe.Product[]>(`${this.STRIPE_URL}/products`);
  }

  public getSubscriptions(params: { client: string }): Observable<Stripe.Subscription[]> {
    return this.http.get<Stripe.Subscription[]>(`${this.STRIPE_URL}/subscriptions`, {
      params
    });
  }

  public checkoutSession(body: CheckoutSessionPostBody): Observable<Stripe.CheckoutSession> {
    return this.http.post<Stripe.CheckoutSession>(`${this.STRIPE_URL}/checkout/session`, body);
  }
}
